// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_container__GtCQ6 {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: #f5f5f5;
  position: relative;
}

.Home_header__0XIge {
  background-color: #1053ad;
  padding: 12px 20px;
  position: relative;
}

.Home_headerContent__SuOpO {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.Home_headerText__U6emI {
  text-align: center;
  flex: 1 1;
}
.Home_headerText__U6emI h1 {
  color: white;
  margin: 0;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 4px;
}
.Home_headerText__U6emI h2 {
  color: white;
  margin: 0;
  font-size: 16px;
  font-weight: normal;
  opacity: 0.9;
}

.Home_headerButtons__fjHIL {
  display: flex;
  gap: 12px;
  align-items: center;
}

.Home_headerButton__MIzEu {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  min-width: 100px;
}
.Home_headerButton__MIzEu:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.Home_headerButton__MIzEu.Home_helpButton__2Rswk {
  background-color: #3b82f6;
  border: 2px solid #ffffff;
}
.Home_headerButton__MIzEu.Home_helpButton__2Rswk:hover {
  background-color: #2563eb;
  border-color: #2563eb;
}
.Home_headerButton__MIzEu.Home_uploadButton__aYsQt {
  background-color: #4caf50;
  border: 2px solid #ffffff;
}
.Home_headerButton__MIzEu.Home_uploadButton__aYsQt:hover {
  background-color: #45a049;
  border-color: #45a049;
}
.Home_headerButton__MIzEu.Home_auditButton__69dia {
  background-color: #fcb530;
  border: 2px solid white;
}
.Home_headerButton__MIzEu.Home_auditButton__69dia:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.9);
}

.Home_content__SYwYM {
  flex: 1 1;
  min-height: 0;
  margin: 0 10px;
  padding: 10px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
}

.Home_diagramContainer__natRX {
  flex: 1 1;
  min-height: 0;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.Home_diagramContainer__natRX:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.3s ease;
}

.Home_formWrapper__SXS5r {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.Home_footer__bq2qo {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.Home_footerContent__44KYR {
  text-align: center;
  color: #666;
  font-size: 14px;
}

.Home_footerButtons__DnO-Q {
  position: absolute;
  right: 20px;
  top: -20px;
  display: flex;
  gap: 10px;
}

.Home_footerButton__N6esn {
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.Home_footerButton__N6esn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.Home_footerButton__N6esn.Home_sendButton__cqR1W {
  background-color: #4caf50;
}
.Home_footerButton__N6esn.Home_sendButton__cqR1W:hover {
  background-color: rgb(68.2788844622, 157.2211155378, 71.8725099602);
}
.Home_footerButton__N6esn.Home_resetButton__G3Ygu {
  background-color: #dd5353;
}
.Home_footerButton__N6esn.Home_resetButton__G3Ygu:hover {
  background-color: rgb(220.2887323944, 51.2112676056, 51.2112676056);
}
.Home_footerButton__N6esn.Home_aiButton__EjSaw {
  background-color: #1565c0;
}
.Home_footerButton__N6esn.Home_aiButton__EjSaw:hover {
  background-color: rgb(18.485915493, 88.9084507042, 169.014084507);
}

.Home_formTrigger__XRt65 {
  position: fixed;
  bottom: 100px;
  left: 40px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 1000;
}
.Home_formTrigger__XRt65:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.Home_formTrigger__XRt65 img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

@media (max-width: 768px) {
  .Home_headerContent__SuOpO {
    flex-direction: column;
    gap: 12px;
  }
  .Home_headerText__U6emI h1 {
    font-size: 20px;
  }
  .Home_headerText__U6emI h2 {
    font-size: 14px;
  }
  .Home_headerButtons__fjHIL {
    gap: 8px;
  }
  .Home_headerButton__MIzEu {
    padding: 6px 12px;
    font-size: 12px;
    min-width: 80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/index.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;AACF;AACE;EACE,YAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AAEE;EACE,YAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAAJ;;AAIA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AADF;;AAIA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;AADF;AAGE;EACE,2BAAA;EACA,yCAAA;AADJ;AAIE;EACE,yBAAA;EACA,yBAAA;AAFJ;AAII;EACE,yBAAA;EACA,qBAAA;AAFN;AAME;EACE,yBAAA;EACA,yBAAA;AAJJ;AAMI;EACE,yBAAA;EACA,qBAAA;AAJN;AAQE;EACE,yBAAA;EACA,uBAAA;AANJ;AAQI;EACE,0CAAA;EACA,sCAAA;AANN;;AAWA;EACE,SAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AARF;;AAWA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AARF;AAUE;EACE,0CAAA;EACA,gCAAA;AARJ;;AAYA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AATF;;AAYA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AATF;;AAYA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AATF;;AAYA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,SAAA;AATF;;AAYA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;AATF;AAWE;EACE,2BAAA;EACA,wCAAA;AATJ;AAYE;EACE,yBAAA;AAVJ;AAWI;EACE,mEAAA;AATN;AAaE;EACE,yBAAA;AAXJ;AAYI;EACE,mEAAA;AAVN;AAcE;EACE,yBAAA;AAZJ;AAaI;EACE,iEAAA;AAXN;;AAgBA;EACE,eAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,yCAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;AAbF;AAeE;EACE,qBAAA;EACA,yCAAA;AAbJ;AAgBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAdJ;;AAmBA;EACE;IACE,sBAAA;IACA,SAAA;EAhBF;EAoBE;IACE,eAAA;EAlBJ;EAqBE;IACE,eAAA;EAnBJ;EAuBA;IACE,QAAA;EArBF;EAwBA;IACE,iBAAA;IACA,eAAA;IACA,eAAA;EAtBF;AACF","sourcesContent":[".container {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  background: #f5f5f5;\n  position: relative;\n}\n\n.header {\n  background-color: #1053ad;\n  padding: 12px 20px;\n  position: relative;\n}\n\n.headerContent {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.headerText {\n  text-align: center;\n  flex: 1;\n\n  h1 {\n    color: white;\n    margin: 0;\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 4px;\n  }\n\n  h2 {\n    color: white;\n    margin: 0;\n    font-size: 16px;\n    font-weight: normal;\n    opacity: 0.9;\n  }\n}\n\n.headerButtons {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.headerButton {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: white;\n  min-width: 100px;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  }\n\n  &.helpButton {\n    background-color: #3b82f6;\n    border: 2px solid #ffffff;\n\n    &:hover {\n      background-color: #2563eb;\n      border-color: #2563eb;\n    }\n  }\n\n  &.uploadButton {\n    background-color: #4caf50;\n    border: 2px solid #ffffff;\n\n    &:hover {\n      background-color: #45a049;\n      border-color: #45a049;\n    }\n  }\n\n  &.auditButton {\n    background-color: #fcb530;\n    border: 2px solid white;\n\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.1);\n      border-color: rgba(255, 255, 255, 0.9);\n    }\n  }\n}\n\n.content {\n  flex: 1;\n  min-height: 0;\n  margin: 0 10px;\n  padding: 10px;\n  margin-bottom: 50px;\n  display: flex;\n  flex-direction: column;\n}\n\n.diagramContainer {\n  flex: 1;\n  min-height: 0;\n  background: #fff;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  \n  &:hover {\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n    transition: box-shadow 0.3s ease;\n  }\n}\n\n.formWrapper {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.footer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 50px;\n  background: white;\n  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 100;\n}\n\n.footerContent {\n  text-align: center;\n  color: #666;\n  font-size: 14px;\n}\n\n.footerButtons {\n  position: absolute;\n  right: 20px;\n  top: -20px;\n  display: flex;\n  gap: 10px;\n}\n\n.footerButton {\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  color: white;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  }\n\n  &.sendButton {\n    background-color: #4caf50;\n    &:hover {\n      background-color: darken(#4caf50, 5%);\n    }\n  }\n\n  &.resetButton {\n    background-color: #dd5353;\n    &:hover {\n      background-color: darken(#e04949, 5%);\n    }\n  }\n\n  &.aiButton {\n    background-color: #1565c0;\n    &:hover {\n      background-color: darken(#1565c0, 5%);\n    }\n  }\n}\n\n.formTrigger {\n  position: fixed;\n  bottom: 100px;\n  left: 40px;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background-color: #fff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  z-index: 1000;\n\n  &:hover {\n    transform: scale(1.1);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  }\n\n  img {\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n  }\n}\n\n// 响应式设计\n@media (max-width: 768px) {\n  .headerContent {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .headerText {\n    h1 {\n      font-size: 20px;\n    }\n\n    h2 {\n      font-size: 14px;\n    }\n  }\n\n  .headerButtons {\n    gap: 8px;\n  }\n\n  .headerButton {\n    padding: 6px 12px;\n    font-size: 12px;\n    min-width: 80px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Home_container__GtCQ6`,
	"header": `Home_header__0XIge`,
	"headerContent": `Home_headerContent__SuOpO`,
	"headerText": `Home_headerText__U6emI`,
	"headerButtons": `Home_headerButtons__fjHIL`,
	"headerButton": `Home_headerButton__MIzEu`,
	"helpButton": `Home_helpButton__2Rswk`,
	"uploadButton": `Home_uploadButton__aYsQt`,
	"auditButton": `Home_auditButton__69dia`,
	"content": `Home_content__SYwYM`,
	"diagramContainer": `Home_diagramContainer__natRX`,
	"formWrapper": `Home_formWrapper__SXS5r`,
	"footer": `Home_footer__bq2qo`,
	"footerContent": `Home_footerContent__44KYR`,
	"footerButtons": `Home_footerButtons__DnO-Q`,
	"footerButton": `Home_footerButton__N6esn`,
	"sendButton": `Home_sendButton__cqR1W`,
	"resetButton": `Home_resetButton__G3Ygu`,
	"aiButton": `Home_aiButton__EjSaw`,
	"formTrigger": `Home_formTrigger__XRt65`
};
export default ___CSS_LOADER_EXPORT___;
